import { NavLink, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import { CreateReportButton } from "@/routes/processes/[processId]/htz/reports/_components/create-report-button";
import {
  ReportsTable,
  ReportTableFilters,
  useDefaultHtzReportListRequest,
} from "@/routes/processes/[processId]/htz/reports/_components/reports-table";
import t from "@/lang/lang";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { HtzBreadcrumbs } from "@/routes/processes/[processId]/htz/_components/htz-breadcrumbs";

export function ReportsIndexRoute() {
  const { processId } = useParams();
  const { data } = useProcessesProcessShowQuery({ id: processId! });

  const [request, setRequest] = useState(
    useDefaultHtzReportListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  if (!data) return null;

  const breadcrumbs = (
    <HtzBreadcrumbs customerId={data.customerId} processId={data.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Berichte")}</BreadcrumbPage>
      </BreadcrumbItem>
    </HtzBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <MilestonePage>
        <MilestonePageHeader>
          <MilestonePageTitle>{t("Berichte")}</MilestonePageTitle>
        </MilestonePageHeader>
        <MilestonePageContent>
          <div className="grid gap-2">
            <div className="flex justify-between">
              <ReportTableFilters
                request={request}
                onRequestChange={setRequest}
              />
              <CreateReportButton processId={processId!} />
            </div>
            <ReportsTable
              request={request}
              onRequestChange={setRequest}
              renderRowLink={renderRowLink}
            />
          </div>
        </MilestonePageContent>
      </MilestonePage>
    </ProcessPageMainTemplate>
  );
}
